<template>
    <div class=" my-2">
        <div class="text-xs-center my-4">
            <h1 class="mb-4">Gana un dolar con Clipclaps</h1>
            <p>Te enseñare a ganar un dolar con Clipclaps en muy cencllos pasos. y <b>Retirar 0.10$ inmediatamente al registrarte.</b></p>
        </div>
        <section>
            <div>
                <h2 class="my-4">Descargar la App en Google Play</h2>
                <p>Clipclaps es una aplicacion donde puedes <b>ganar dinero viendo cortos videos</b>.</p>
                <p>Solo tienes que descargar la aplicacion aqui =>>> <a href="https://play.google.com/store/apps/details?id=com.sanhe.clipclaps&hl=es_CO&gl=US" target="_blank" rel="noopener noreferrer">Descargar en google play</a></p>
                <p><b>Create una cuenta</b> y configura la aplicacion a tu gusto.</p>
                <div>
                    <h3 class="my-3">Y como puedo ganarme el dolar?</h3>
                    <p>Tranquilo, Primero tienes que <b>Copiar</b> este codigo de aca =>>   <b>4196211937</b> - <b>Pero ojo!!!</b> Anotalo en un papel porque no permite cpiar y pegar en la app.</p>
                    <p>Una vez copiado el codigo te vas a  la parte superior a la derecha y apretas el boton</p>
                    <p>Se te abrira una ventana nueva donde te pedira el codigo para poder <b>Ganarte 1$</b> y listo, luego puedes seguir ganando dinero viendo los videos.</p>
                </div>
            </div>
            <div class="d-flex  align-center">
                <div class=" align-center">
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/kV0oh7aNM0Y" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
            </div>
            <div>
                <h2 class="my-4">Retirar 0.10$ a tu cuenta paypal</h2>
                <p>Yo aun no recomiendo esto una ves abre la aplicacion. Tienes que esperar que pasen varios dias para luego retirarlos porque sino no te los daran.</p>
                <p><b>Porque?</b> porque si asi fuera entonces perderian dinero con usuarios que se crean muchas cuentas y de 0.10 en 0.10 le sacarian mucho dinero.</p>
                <p>Pero supongamos que deseas hacerlo. Tienes que irte a la pantalla de inicio, selecciona las monedas o los billetes que aparecen en la parte superior a la izquierda y te aparecera que puedes cambiarlo o comprar mas monedas.</p>
                <p>Selecciona que quieres cambiarlo, tienes que añadir tu cuenta <b>paypal</b> y una vez añadida, puedes solicitar tu retiro por 0.10$.</p>
            </div>
        </section>
        <section>
            <Menu></Menu>
        </section>
    </div>
</template>
<script>
    import Menu from '@/components/blog/menu'
    export default {
        components:{
            Menu
        },
        data (){
            return {
                item:4
            }
        }
    }
</script>